export default __webpack_public_path__ + "static/media/traceparentLogo_Horizontal.1f117d5c.svg";